// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const postApi = baseApi.injectEndpoints({
  reducerPath: "postApi",
  endpoints: (builder) => ({
    deleteComment: builder.mutation({
      query: (slug) => {
        return {
          url: `delete-comment/${slug}`,
          method: "DELETE",
          // body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deletePost: builder.mutation({
      query: (slug) => {
        return {
          url: `post-delete/${slug}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      invalidatesTags: ["deletePost"],
    }),
    getPostDetailsWithComment: builder.query({
      query: (slug) => {
        return {
          url: `get-post-details/${slug}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getAllPosts: builder.query({
      query: ({ search, limit, page }) => {
        return {
          url: `get-all-post?search=${search}&page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useDeleteCommentMutation,
  useDeletePostMutation,
  useGetPostDetailsWithCommentQuery,
  useGetAllPostsQuery,
} = postApi;
